/* eslint-disable */
import React from "react";
import styles from "./Careers.module.css";
import NavBar from "../../components/shared/NavBar/NavBar";
import Underline from "../../assets/common/underline.svg";
import {
  CareerCards,
  CarretPageText,
  MAX_MOBILE_WIDTH,
  jobsLink,
} from "../../components/shared/helpers";
import { useMediaQuery } from "react-responsive";
import { useRef } from "react";
import BottomNav from "../../components/shared/BottomNav/BottomNav";
import ZohoWidget from "../../components/ZohoWidget";
import CareersCarousel from "./CareersCarousel";

export default function Careers() {
  const { title, subTitle, desc1, desc2 } = CarretPageText;

  const isMobile = useMediaQuery({ maxWidth: MAX_MOBILE_WIDTH });
  const exploreOpenRolesRef = useRef(null);

  const handleClick = () => {
    exploreOpenRolesRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.container}>
      <NavBar />
      <CareersCarousel />

      <div className={styles["sub-container"]}>
        <div className={styles["view-ops-container"]} onClick={handleClick}>
          <div className={styles["ops-text"]}>View Job Opportunities</div>
        </div>
        <div className={styles["right"]}>
          <div className={styles["sub-title"]}>{subTitle}</div>
          <div className={styles["description"]}>{desc1}</div>
          <div className={styles["description"]} style={{ marginTop: "24px" }}>
            {desc2}
          </div>
        </div>
      </div>

      <div className={styles["main-title"]}>
        Why Coschool
        <img src={Underline} className={styles["under-curve"]} />
      </div>

      <div className={styles["cards"]}>
        <Card item={CareerCards[0]} />
        <Card item={CareerCards[1]} />
        <Card item={CareerCards[2]} />
      </div>

      <div className={styles["cards"]}>
        <Card item={CareerCards[3]} />
        <Card item={CareerCards[4]} />
      </div>

      <div className={styles["main-title"]}>Impact Starts From Day One!</div>

      {/* Add the ref here and give it a minimum height */}
      <div
        ref={exploreOpenRolesRef}
        style={{
          // marginTop: "48px",
          // marginBottom: "48px",
          minHeight: "600px", // Ensure there's always content here
          // padding: "20px 0"
        }}
      >
        <ZohoWidget />
      </div>

      <BottomNav />
    </div>
  );
}

const Card = ({ item }) => {
  return (
    <div className={styles["card"]}>
      <div className={styles["card-title"]}>{item.title}</div>
      <div className={styles["card-description"]}>{item.desc}</div>
    </div>
  );
};